import React from "react";
import Loader from "react-loader-spinner";
import months from "../utils/months";

const Hero = (props) => {
  const date = new Date(props.lastUpdated);
  const time = months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear() + " " + date.toLocaleString([], { hour: "numeric", minute: "numeric", hour12: true });
  return (
    <div className="hero">
      <h1>
        <span>Cov</span>Ind
      </h1>
      <p>A webapp to track COVID-19 Virus outbreak in India</p>
      {props.lastUpdated ? (
        <span id="lastupdated">
          <Loader type="Rings" height={24} width={24} color="#ff1744" />
          Last updated : {time}
        </span>
      ) : null}
    </div>
  );
};

export default Hero;
